import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import GeneratorTool from './components/GeneratorTool';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminDashboard from './pages/AdminDashboard';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SalesRep from './pages/SalesRep';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AccessDenied from './pages/AccessDenied';
import TrainingPortal from './pages/TrainingPortal';
import CategoryMaterials from './pages/CategoryMaterials';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import TestForms from './pages/TestForms';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Admin Dashboard Route */}
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* Legal Pages */}
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            
            {/* Sales Rep Application Page */}
            <Route path="/sales-rep" element={<SalesRep />} />
            
            {/* Test/Debug Route */}
            <Route path="/test-forms" element={<TestForms />} />
            
            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            
            {/* Protected Training Portal Routes */}
            <Route path="/training-portal" element={
              <ProtectedRoute>
                <TrainingPortal />
              </ProtectedRoute>
            } />
            <Route path="/training-portal/materials/:categoryId" element={
              <ProtectedRoute>
                <CategoryMaterials />
              </ProtectedRoute>
            } />
            
            {/* Main Website Route */}
            <Route path="/" element={
              <>
                <Header />
                <main>
                  <Hero />
                  <Services />
                  <About />
                  <GeneratorTool />
                  <Projects />
                  <Contact />
                </main>
                <Footer />
              </>
            } />
          </Routes>
          <Toaster />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
